import React from 'react';
import List from './components/List';
import onKeyDown from './EventHandlers';
import ListItemPlugin from './ListItemPlugin';
import type {
  ComponentProps,
  EditorPlugin,
  ListElement,
} from '../../types/aha-editor';
import type { ListElementType, ListType } from './constants';

const ListComponentPluginFactory = (
  listType: ListType,
  elementType: ListElementType
): EditorPlugin => {
  const ListComponent: React.FC<ComponentProps<ListElement>> = ({
    children,
    ...props
  }) => (
    <List type={listType} {...props}>
      {children}
    </List>
  );

  return {
    name: `${listType} List component plugin`,
    dependencies: [ListItemPlugin],
    component: {
      type: elementType,
      component: ListComponent,
    },
  };
};

export const UnorderedListComponentPlugin = ListComponentPluginFactory(
  'ul',
  'ul_list'
);
export const OrderedListComponentPlugin = ListComponentPluginFactory(
  'ol',
  'ol_list'
);
export const CheckboxListComponentPlugin = ListComponentPluginFactory(
  'checklist',
  'checklist'
);
export const DefinitionListComponentPlugin = ListComponentPluginFactory(
  'dl',
  'dl_list'
);

export const ListKeydownHandlerPlugin = {
  name: 'List Keydown handler plugin',
  handlers: {
    onKeyDown,
  },
};

const ListComponentsPlugin = [
  ListKeydownHandlerPlugin,
  UnorderedListComponentPlugin,
  OrderedListComponentPlugin,
  CheckboxListComponentPlugin,
  DefinitionListComponentPlugin,
];

export default ListComponentsPlugin;
